import { useMixpanel } from '@context/MixpanelProvider';
import { Button, Card, CardContent, CardHeader, Paper, Typography } from '@mui/material';
import { DYNAMIC_SURVEY_EVENTS, INTERVIEW_EVENTS } from '@utils/eventSchema';
import { useNavigate } from 'react-router-dom';

const SendToParticipantsCard = ({
  studyId,
  studyType = 'survey',
  buttonVariant = 'custom',
  trackContext,
}) => {
  const navigate = useNavigate();
  const { trackEvent } = useMixpanel();

  const handleClick = () => {
    if (trackContext === 'interview') {
      trackEvent('interview', {
        ...INTERVIEW_EVENTS.CLICKED_INTERVIEW_SEND_TO_AI_PARTICIPANTS,
      });
    } else if (trackContext === 'survey') {
      trackEvent('dynamicSurvey', {
        ...DYNAMIC_SURVEY_EVENTS.CLICKED_SURVEY_SEND_TO_AI_PARTICIPANTS,
      });
    }
    navigate(`/ai-participants/study/${studyId}?type=${studyType}`);
  };

  return (
    <Card variant="outlined" sx={{ p: 0, height: '100%' }}>
      <CardHeader
        title="Send to Participants"
        titleTypographyProps={{ variant: 'h6' }}
        sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
      />
      <CardContent sx={{ p: 3 }}>
        <Button
          variant={buttonVariant}
          color="primary"
          fullWidth
          size="large"
          sx={{ mb: 2 }}
          onClick={handleClick}
          disabled={!studyId}
        >
          Send to Participants
        </Button>
        <Paper variant="outlined" sx={{ bgcolor: 'grey.100', p: 2 }}>
          <Typography variant="subtitle2" fontWeight="medium" gutterBottom>
            Participant Information
          </Typography>
          <Typography variant="body2" color="text.secondary">
            AI participants generate responses from their demographic profiles. Non-AI participants
            are contacted by email with your study link. AI-generated results are labeled in your
            dataset.
          </Typography>
        </Paper>
      </CardContent>
    </Card>
  );
};

export default SendToParticipantsCard;
